import { FC } from 'react';
import PropTypes from 'prop-types';
import {
    Skeleton,
    Card,
    CardHeader,
    CardContent,
    Grid,
} from '@material-ui/core';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';

// export type GridSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type TskeletonType = 'CardSkeleton' | 'FormEdit' | 'PageLoader' | 'TableSkeleton' | 'TreeViewSkeleton';
interface IskeletonProps {
    skeletonType: TskeletonType;
    repeatGridItems?: number;
    repeatSkeleton?: number;
    // gridSize?: GridSize;
}
const CustomSkeleton: FC<IskeletonProps> = (props): any => {
    const { skeletonType, repeatSkeleton = 1, repeatGridItems = 1 } = props;
    const CardSkeleton = () => (
        <Grid container spacing={3} marginBottom={3}>
            {Array.from(Array(repeatGridItems).keys()).map((index) => (
                <Grid key={index.toString()} item lg={2} md={2} sm={4} xs={12}>
                    <Card>
                        <CardContent>
                            <Skeleton sx={{ height: 90 }} animation="pulse" variant="rectangular" />
                            <CardHeader
                                avatar={<Skeleton animation="pulse" variant="circular" width={40} height={40} />}
                                title={<Skeleton animation="pulse" height={10} width="40%" />}
                                subheader={<Skeleton animation="pulse" height={10} width="60%" />}
                            />
                            <Skeleton animation="pulse" height={10} style={{ marginBottom: 6 }} />
                            <Skeleton animation="pulse" height={10} width="100%" />
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );

    const FormEdit = () => (
        <Grid container spacing={2}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={80} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Skeleton variant="rectangular" height={32} />
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={4}>
                        <Skeleton variant="rectangular" height={32} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
    const PageLoader = () => (
        <Grid container spacing={2}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={35} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={80} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Skeleton variant="rectangular" height={80} />
            </Grid>
        </Grid>
    );

    const TreeViewSkeleton = () => (
        <TreeView defaultCollapseIcon={<Skeleton variant="rectangular" width={24} height={24} />} defaultExpandIcon={<Skeleton variant="rectangular" width={24} height={24} />} multiSelect>
            {Array.from(Array(repeatSkeleton).keys()).map((index) => (
                <TreeItem key={index.toString()} nodeId={`node-${index}`} label={<Skeleton animation="wave" height={40} />} >
                    <TreeItem nodeId={`node-${index}-1`} label={<Skeleton animation="wave" height={20} />} />
                    <TreeItem nodeId={`node-${index}-2`} label={<Skeleton animation="wave" height={20} />} />
                </TreeItem>
            ))}
        </TreeView>
    );

    if (skeletonType === 'CardSkeleton') {
        return Array.from(Array(repeatSkeleton).keys()).map((index) => <CardSkeleton key={index.toString()} />);
    }
    if (skeletonType === 'FormEdit') {
        return Array.from(Array(repeatSkeleton).keys()).map((index) => <FormEdit key={index.toString()} />);
    }
    if (skeletonType === 'PageLoader') {
        return Array.from(Array(repeatSkeleton).keys()).map((index) => <PageLoader key={index.toString()} />);
    }
    if (skeletonType === 'TableSkeleton') {
        return (
            <Grid>
                <Skeleton sx={{ ml: 2, mr: 2, height: 65 }} />
                {Array.from(Array(7).keys()).map((index) => <Skeleton key={index} sx={{ ml: 2, mr: 2, mt: -2, height: 60 }} />)}
            </Grid>
        );
    }
    if (skeletonType === 'TreeViewSkeleton') {
        return <TreeViewSkeleton />;
    }
    return <FormEdit />;
};

CustomSkeleton.propTypes = {
    skeletonType: PropTypes.any.isRequired,
    repeatGridItems: PropTypes.number,
    repeatSkeleton: PropTypes.number,
};

export default CustomSkeleton;
